<template>
  <div class="container">
    <div class="title">《{{title}}》 </div>
    <el-button type="text" size="mini" @click="handleSelect">选择</el-button>
  </div>
</template>
<script>
import { getToken, setStorage, getStorage } from '@/utils/auth'
export default {
  name: 'SelectMovie',
  components: {
  },
  props: {
    value: {
      type: String
    },
    list: {
      type: Array
    }
  },
  data () {
    return {

    }
  },
  computed: {
    title () {
      let item = this.list.find(item => {
        return this.value == item.id
      }) || {}

      return item.title || this.value
    }
  },
  mounted () {
  },
  methods: {
    handleSelect () {
      this.$selectMovie.show({
        list: this.list,
        default: this.value,
        success: (movieId) => {
          this.$emit('input', movieId)
          this.$selectMovie.hide()
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .container {
    background: white;
    border: 1px solid #e1e1e1;
    display: flex;
    width: 194px;
  }
  .title {
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/SelectMovie/index.vue